"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _SourceItems = require("../../constants/SourceItems");
var _LayerSource = require("./LayerSource.styled");
var _DefaultComponentMap = _interopRequireDefault(require("./DefaultComponentMap"));
var _PropTypes = require("./PropTypes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LayerSource = function LayerSource(_ref) {
  var animation = _ref.animation,
    source = _ref.source,
    layer = _ref.layer,
    componentMap = _ref.componentMap,
    showMediaControls = _ref.showMediaControls,
    autoPlayMedia = _ref.autoPlayMedia,
    onTogglePlayback = _ref.onTogglePlayback,
    onToggleAudioPlayback = _ref.onToggleAudioPlayback,
    onVolumeChanged = _ref.onVolumeChanged,
    onSeekTimeChanged = _ref.onSeekTimeChanged,
    mediaPlayer = _ref.mediaPlayer,
    hoverComponent = _ref.hoverComponent,
    audioPlayer = _ref.audioPlayer,
    serverTime = _ref.serverTime,
    serverTimeDelta = _ref.serverTimeDelta,
    hasBorderRadius = _ref.hasBorderRadius,
    layout = _ref._id,
    cameraPresenterLayersCount = _ref.cameraPresenterLayersCount,
    AttendeeTileComponent = _ref.AttendeeTileComponent,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    loggedInUser = _ref.loggedInUser,
    currentUserAttendeeId = _ref.currentUserAttendeeId,
    localAttendeeVideoInput = _ref.localAttendeeVideoInput;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showHoverComponent = _useState2[0],
    setShowHoverComponent = _useState2[1];
  var componentMapWithDefaults = _objectSpread(_objectSpread({}, _DefaultComponentMap["default"]), componentMap);
  var sourceType = source.type;
  var layerIsContent = (layer === null || layer === void 0 ? void 0 : layer.isContent) !== false;
  var SourceComponent = componentMapWithDefaults[sourceType];
  var props = [_SourceItems.VIDEO_FILE, _SourceItems.AUDIO_FILE, _SourceItems.PDF_FILE].includes(sourceType) ? {
    source: source,
    showControls: showMediaControls,
    autoPlay: autoPlayMedia,
    onTogglePlayback: onTogglePlayback,
    onToggleAudioPlayback: onToggleAudioPlayback,
    onVolumeChanged: onVolumeChanged,
    onSeekTimeChanged: onSeekTimeChanged,
    mediaPlayer: mediaPlayer,
    audioPlayer: audioPlayer,
    serverTime: serverTime,
    serverTimeDelta: serverTimeDelta
  } : {
    source: source,
    layer: layer,
    cameraPresenterLayersCount: cameraPresenterLayersCount,
    AttendeeTileComponent: AttendeeTileComponent,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    loggedInUser: loggedInUser,
    currentUserAttendeeId: currentUserAttendeeId,
    localAttendeeVideoInput: localAttendeeVideoInput
  };
  return /*#__PURE__*/_react["default"].createElement(_LayerSource.Wrapper, (0, _extends2["default"])({
    "data-testid": "layer-source-".concat(source._id),
    style: layer === null || layer === void 0 ? void 0 : layer.style,
    hasBorderRadius: hasBorderRadius,
    shouldContainVideo: sourceType === _SourceItems.VIDEO_FILE
  }, animation, {
    onMouseEnter: function onMouseEnter() {
      return setShowHoverComponent(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowHoverComponent(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(SourceComponent, props), showHoverComponent && layerIsContent && hoverComponent ? hoverComponent({
    source: source,
    layout: layout
  }) : null);
};
LayerSource.propTypes = _objectSpread(_objectSpread({}, _PropTypes.LayerSource), {}, {
  // This can be passed in, so that we can override w/ components that have a meetingSession bound
  componentMap: _propTypes.object,
  showMediaControls: _propTypes.bool,
  autoPlayMedia: _propTypes.bool,
  onTogglePlayback: _propTypes.func,
  onToggleAudioPlayback: _propTypes.func,
  onVolumeChanged: _propTypes.func,
  onSeekTimeChanged: _propTypes.func,
  mediaPlayer: _PropTypes.MediaPlayer,
  // These props are passed to a `motion` and `AnimatePresence` wrapped element:
  // See: https://www.framer.com/api/motion/
  animation: (0, _propTypes.shape)({
    initial: _propTypes.object,
    animate: _propTypes.object,
    exit: _propTypes.object,
    transition: _propTypes.object
  }),
  hoverComponent: _propTypes.func,
  audioPlayer: _PropTypes.AudioPlayer,
  serverTime: _propTypes.number,
  serverTimeDelta: _propTypes.number,
  cameraPresenterLayersCount: _propTypes.number,
  hasBorderRadius: _propTypes.bool,
  AttendeeTileComponent: _propTypes.elementType,
  attendeeTiles: _propTypes.object,
  meetingSession: _propTypes.object,
  loggedInUser: _propTypes.object,
  currentUserAttendeeId: _propTypes.string,
  localAttendeeVideoInput: _propTypes.object
});
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(LayerSource);